// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
import EventSourcePolyfill from 'eventsource'

declare global {
  interface Window {
    EventSourcePolyfill: any
    EventSource: any
  }
}

if (typeof window === 'object') {
  window.EventSourcePolyfill = EventSourcePolyfill
  if (!window.EventSource) {
    window.EventSource = EventSourcePolyfill
  }
}
